import React, { useState } from 'react';
import api from '../../lib/api';

const ForceChangePinModal = ({ onSuccess }) => {
  const [newPin, setNewPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePinInput = (value, setter) => {
    // N'accepter que les chiffres et limiter à 4 caractères
    const cleaned = value.replace(/\D/g, '').slice(0, 4);
    setter(cleaned);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (newPin.length !== 4) {
      setError('Le code PIN doit contenir exactement 4 chiffres');
      return;
    }

    if (!/^\d{4}$/.test(newPin)) {
      setError('Le code PIN ne doit contenir que des chiffres');
      return;
    }

    if (newPin !== confirmPin) {
      setError('Les codes PIN ne correspondent pas');
      return;
    }

    setLoading(true);

    try {
      await api.post('/auth/employee/force-change-pin', {
        new_pin: newPin
      });

      // Succès
      alert('✅ Code PIN changé avec succès !');
      onSuccess();
    } catch (err) {
      console.error('Erreur changement PIN:', err);
      setError(err.response?.data?.detail || 'Erreur lors du changement de code PIN');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🔐</span>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Changement de code PIN obligatoire
          </h2>
          <p className="text-gray-600">
            Pour votre sécurité, vous devez changer votre code PIN temporaire
          </p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
            <p className="text-sm text-red-800">❌ {error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nouveau code PIN (4 chiffres)
            </label>
            <input
              type="password"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength="4"
              value={newPin}
              onChange={(e) => handlePinInput(e.target.value, setNewPin)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-center text-2xl tracking-widest"
              placeholder="****"
              required
              disabled={loading}
              autoFocus
            />
            <p className="text-xs text-gray-500 mt-1 text-center">
              {newPin.length}/4 chiffres
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Confirmer le code PIN
            </label>
            <input
              type="password"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength="4"
              value={confirmPin}
              onChange={(e) => handlePinInput(e.target.value, setConfirmPin)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-center text-2xl tracking-widest"
              placeholder="****"
              required
              disabled={loading}
            />
            <p className="text-xs text-gray-500 mt-1 text-center">
              {confirmPin.length}/4 chiffres
            </p>
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <p className="text-sm text-yellow-800">
              ⚠️ <strong>Important :</strong> Ce code PIN temporaire ne peut être utilisé qu'une seule fois. 
              Choisissez un code PIN à 4 chiffres que vous retiendrez facilement.
            </p>
          </div>

          <button
            type="submit"
            disabled={loading || newPin.length !== 4 || confirmPin.length !== 4}
            className="w-full bg-gradient-to-r from-blue-500 to-green-500 text-white py-3 px-4 rounded-lg font-semibold hover:from-blue-600 hover:to-green-600 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <>
                <span className="animate-spin mr-2">⏳</span>
                Changement en cours...
              </>
            ) : (
              'Changer mon code PIN'
            )}
          </button>
        </form>

        <p className="text-xs text-gray-500 text-center mt-4">
          Vous ne pouvez pas ignorer cette étape
        </p>
      </div>
    </div>
  );
};

export default ForceChangePinModal;
